import { GetServerSideProps } from 'next'

import CardLists from '@/components/CardLists/CardLists'
import DecksTable from '@/components/DecksTable/DecksTable'
import DefaultHead from '@/components/DefaultHead/DefaultHead'
import Main from '@/components/Main/Main'
import MidBanner from '@/components/MidBanner/MidBanner'
import Panels from '@/components/Panels/Panels'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'
import SubMenu from '@/components/SubMenu/SubMenu'
import Tabs from '@/components/Tabs/Tabs'
import { CommandersPageProps } from '@/types/page'
import { COLORS, TIMESPANS } from '@/utils/constants'
import { serverSidePropsFor } from '@/utils/helpers.server'
import useDirectories from '@/utils/useDirectories'

const SUBMENU_ITEMS = [
  { name: 'Past 2 Years', url: '/commanders' },
  { name: 'Past Month', url: '/commanders/month' },
  { name: 'Past Week', url: '/commanders/week' },
]

const colorMenuItems = (cid: string) => [
  { name: 'Commanders', url: `/commanders/${cid}` },
  { name: 'Staples', url: `/commanders/${cid}/staples` },
  { name: 'Mana Staples', url: `/commanders/${cid}/mana-staples` },
]

export const isColorPage = (subpage: string) =>
  Object.values(COLORS)
    .map((color) => color.toLowerCase())
    .includes(subpage)

export const isTimespanPage = (subpage: string) => TIMESPANS.includes(subpage)

const CommandersPage = ({ data }: CommandersPageProps) => {
  const { subpage, subsubpage, subsubsubpage } = useDirectories()

  const isIndex = !subpage && !subsubpage && !subsubsubpage
  const hasTabs = isColorPage(subpage) || isTimespanPage(subpage)
  const showPanels = !hasTabs && subpage !== 'vehicles'
  const topLeftEdge = isColorPage(subpage) ? !subsubpage : !subpage

  const content =
    subsubsubpage === 'decks' ? (
      // @ts-ignore
      <DecksTable rows={data.table} />
    ) : (
      <>
        <Tabs>{hasTabs && <SubMenu items={isColorPage(subpage) ? colorMenuItems(subpage) : SUBMENU_ITEMS} />}</Tabs>
        <CardLists
          card={data.container.json_dict.card}
          disabledSortMethods={isColorPage(subpage) || isIndex || isTimespanPage(subpage) ? ['percent', 'synergy'] : []}
          initCardLists={data.container.json_dict.cardlists}
          topLeftEdge={topLeftEdge}
        />
      </>
    )

  const artCrop = !data.container.json_dict.card?.content_warning
    ? data.container.json_dict.card?.image_uris[0].art_crop
    : ''

  return (
    <Main artCrop={artCrop}>
      <DefaultHead data={data} />
      {showPanels ? <Panels data={data} /> : <SimpleHeader>{data.header}</SimpleHeader>}
      <MidBanner />
      {content}
    </Main>
  )
}

export const getServerSideProps: GetServerSideProps<CommandersPageProps> = async ({ req }) =>
  serverSidePropsFor(`${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/pages/commanders/year.json`, req.headers)

export default CommandersPage
